import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export enum AiAnalyzedFileSource {
  UPLOAD = "upload",
  FORWARD = "forward",
}

const aiAnalyzedFileSchema_ = z.object({
  _id: zExt.objectId(),
  teamId: zExt.objectId(),
  url: z.string(),
  filename: z.string(),
  mimeType: z.string(),
  source: createEnum(AiAnalyzedFileSource),
  analysis: z.string(),
  createdAt: z.date(),
  updatedAt: z.date(),
});
export const aiAnalyzedFileSchema: z.ZodType<AiAnalyzedFile> =
  aiAnalyzedFileSchema_;
export interface AiAnalyzedFile extends z.infer<typeof aiAnalyzedFileSchema_> {}

export interface CreateAiAnalyzedFileParams {
  teamId: string;
  url: string;
  filename: string;
  mimeType: string;
  source: AiAnalyzedFileSource;
  analysis: string;
}
